module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-4@2x__24b86bd0cb2fff5e0bcc9b32b94d7995.png";